module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/deleted-file-c1dae332e98aefb9986701f84f0dfc13.svg";